<script>
import { useHead } from '@unhead/vue';
import structuredData from './lib/structuredData';

export default {
  name: 'StructuredDataWebPage',
  render() {
    // Return null since this is only rendering meta data
    return null;
  },
  props: {
    route: {
      type: Object,
      default: () => ({})
    },
    canonicalUrl: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    useHead({
      script: [structuredData(props, 'webpage')]
    });
  }
};
</script>
